import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Icon } from '../../atoms';

const getColor = (props) => {
  switch (true) {
    case props.$primary:
      return 'var(--primary-default)';
    case props.$secondary:
      return 'var(--wash-orange-default)';
    case props.$tertiary:
      return 'var(--wash-gray-default)';
    case props.$critical:
      return 'var(--wash-red-default)';
    case props.$naked:
    default:
      return 'transparent';
  }
};

const Button = styled.button`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border: none;
  position: relative;

  border-radius: ${({ $small }) => ($small ? '16px' : '20px')};
  padding: 4px;
  box-sizing: border-box;

  width: ${({ $small }) => ($small ? '32px' : '40px')};
  height: ${({ $small }) => ($small ? '32px' : '40px')};

  transition: background-color 0.1s ease-in-out, color 0.1s ease-in-out;
  color: ${({ $iconColor }) => $iconColor};
  cursor: pointer;

  ${(props) => {
    switch (true) {
      case props.$primary:
        return `
            background-color: var(--primary-default);
            color: var(--white);

            &:hover:not(:active) {
              background-color: var(--primary-hover);
            }
              
            &:active {
              background-color: var(--primary-pressed);
            }
          `;
      case props.$secondary:
        return `
            background-color: var(--wash-orange-default);
            color: var(--primary-default);

            &:hover:not(:active) {
              background-color: var(--wash-orange-hover);
            }
            &:active {
              background-color: var(--wash-orange-pressed);
            }
          `;
      case props.$tertiary:
        return `
            background-color: var(--wash-gray-default);
            color: var(--content-title);

            &:hover:not(:active) {
              background-color: var(--wash-gray-hover);
            }
            &:active {
              background-color: var(--wash-gray-pressed);
            }
          `;
      case props.$critical:
        return `
            background-color: var(--wash-red-default);
            color: var(--critical-default);

            &:hover:not(:active) {
              background-color: var(--wash-red-hover);
            }
            &:active {
              background-color: var(--wash-red-pressed);
            }
          `;
      case props.$naked:
      default:
        return `
            background-color: transparent;
            color: var(--content-subtitle);

            &:hover:not(:active) {
              background-color: var(--wash-gray-hover);
            }
            &:active {
              background-color: var(--wash-gray-pressed);
              color: var(--content-title);
            }
          `;
    }
  }}
  &:disabled:hover:not(:active),
  &:disabled:active {
    background-color: ${(props) => getColor(props)};
    cursor: not-allowed;
  }
`;

const IconButton = ({
  type = 'button',
  className = null,
  small = false,
  primary = false,
  secondary = false,
  tertiary = false,
  naked = false,
  critical = false,
  iconName,
  iconSize = 24,
  iconDisplaySize = undefined,
  iconColor = 'currentColor',
  onClick = null,
  children = null,
  disabled = false
}) => (
  <Button
    $small={small}
    onClick={onClick}
    className={className}
    type={type}
    $primary={primary}
    $secondary={secondary}
    $tertiary={tertiary}
    $naked={naked}
    $critical={critical}
    disabled={disabled}
  >
    <Icon name={iconName} size={iconSize} displaySize={iconDisplaySize} color={iconColor} />
    {children}
  </Button>
);

IconButton.propTypes = {
  className: PropTypes.string,
  small: PropTypes.bool,
  iconName: PropTypes.string.isRequired,
  iconSize: PropTypes.number,
  iconDisplaySize: PropTypes.number,
  onClick: PropTypes.func,
  iconColor: PropTypes.string,
  type: PropTypes.string,
  children: PropTypes.node,
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  tertiary: PropTypes.bool,
  critical: PropTypes.bool,
  naked: PropTypes.bool,
  disabled: PropTypes.bool
};

export { IconButton };
